export function hasPermission({ code, level }) {
  const perms = JSON.parse(localStorage.getItem("permissions")) || {};

  const current = perms[code];
  if (!current) return false;

  return current.includes(level);
}
